<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <modal-detail
      :store-module-name="STORE_MODULE_NAME"
      :is-modal-active.sync="isModalDetailActive"
      :show.sync="show"
      :data="modalDetailData"
    />
    <modal-link
      :store-module-name="STORE_MODULE_NAME"
      :is-modal-link-active.sync="isModalLinkActive"
      :show.sync="show"
      :data="modalDetailData"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-1">
          <b-row>
            <b-col cols="2">
              <b-card-text>
                {{ $t('Partner') }}
              </b-card-text>
            </b-col>
            <b-col cols="10">
              <v-select
                id="register-respDataPartner"
                v-model="profilePartnerId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="firstName"
                :options="respDataPartner"
                :reduce="(respDataPartner) => respDataPartner._id"
                :filterable="false"
                class="select-size-lg"
                @search="onSearchPartner"
              >
                <div
                  slot="list-footer"
                  class="m-1"
                >
                  <b-row>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        block
                        :disabled="currentPagePartner <= 1 ? true :false"
                        @click="nextPagePartner(currentPagePartner -1)"
                      >
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </b-button>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        block
                        disabled
                      >
                        {{ currentPagePartner }}
                      </b-button>
                    </b-col>
                    <b-col cols="4">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        block
                        :disabled="(currentPagePartner * perPagePartner) >= queriedItemsPartner ? true :false"
                        @click="nextPagePartner(currentPagePartner + 1)"
                      >
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </b-button>
                    </b-col>
                  </b-row>

                </div>
              </v-select>
            </b-col>
          </b-row>

        </div>

      </b-card>
      <b-card
        no-body
        class="mt-2"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t('Show') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector v-select-custom"
                @input="pageSize"
              />
              <label for="">{{ $t('entries') }}</label>
              <span class="ml-2 text-muted">{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t("of") }} {{ queriedItems }}</span>
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="b-col-custom"
            >
              <div class="d-flex align-items-center justify-content-end">
                <flat-pickr
                  v-model="day"
                  class="form-control"
                  :config="configs"
                />
                <!-- <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search')+'...'"
                  @input="typing($event)"
                /> -->
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="d-flex"
                  @click="currentTime()"
                >
                  <feather-icon
                    icon="ClockIcon"
                  />
                </b-button>
              <!-- <b-form-file
                @change="importFileJson"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".json"
              /> -->
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          striped
          responsive
          class="position-relative"
          :items="respData"
          :fields="tableColumns"
          primary-key="_id"
          show-empty
          :empty-text="$t('No matching records found')"
          style="height: 60vh;"
        >
          <!-- Column: Images -->
          <template #cell(member)="data">
            <b-row>
              <b-card-text v-if="data.item.userInfoId !== null">
                {{ data.item.queueBookingId.userInfoId.firstName }} {{ data.item.queueBookingId.userInfoId.lastName }}
              </b-card-text>
            </b-row>
          </template>
          <!-- Column: Images -->
          <template #cell(partner)="data">
            <b-row>
              <b-card-text v-if="data.item.queueBookingId !== null">
                {{ data.item.queueBookingId.profilePartnerId.firstName }} {{ data.item.queueBookingId.profilePartnerId.lastName }}
              </b-card-text>
            </b-row>
          </template>
          <!-- Column: Images -->
          <template #cell(start)="data">
            <b-row>
              <b-card-text>
                {{ data.item.start | formatTime }}
              </b-card-text>
            </b-row>
          </template>
          <!-- Column: Images -->
          <template #cell(end)="data">
            <b-row>
              <b-card-text>
                {{ data.item.end | formatTime }}
              </b-card-text>
            </b-row>
          </template>
          <!-- Column: Action -->
          <template #cell(action)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="modalDetailShow( data.item )">
                <feather-icon icon="ListIcon" />
                <span class="align-middle ml-50">{{ $t('Detail') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="modalLinkShow( data.item )">
                <feather-icon icon="ListIcon" />
                <span class="align-middle ml-50">{{ $t('Link') }}</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteData( data.item._id )">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ currentPage * perPage - (perPage - 1) }} -
                {{
                  queriedItems - currentPage * perPage > 0
                    ? currentPage * perPage
                    : queriedItems
                }}
                {{ $t("of") }} {{ queriedItems }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="queriedItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="nextPage"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
  BImg,
  BAvatar,
  BFormInput, BButton,
  BTable, BPagination, BDropdown, BOverlay,
  BCardText,
  BDropdownItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/hero/listServiceQueue'
import debounce from 'debounce'
// eslint-disable-next-line import/extensions
import { Thai } from 'flatpickr/dist/l10n/th.js'
import ModalDetail from './components/ModalDetail.vue'
import ModalLink from './components/ModalLink.vue'

const STORE_MODULE_NAME = 'listServiceQueue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BCardText,
    flatPickr,
    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    ModalDetail,
    ModalLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      day: this.formatDate(new Date(Date.now())),
      currentPage: 1,
      searchQuery: '',
      perPage: localStorage.getItem('itemsPerPage') ? localStorage.getItem('itemsPerPage') : 30,
      isSidebarActive: false,
      sidebarData: {},
      show: false,
      // vue select limit
      profilePartnerId: '',
      searchPartner: '',
      currentPagePartner: 1,
      perPagePartner: 10,
      configs: {
        enableTime: false,
        dateFormat: 'd-m-Y',
        locale: Thai,
      },
      isModalDetailActive: false,
      isModalLinkActive: false,
      modalDetailData: {},
      perPageOptions,
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'id', label: this.$t('ID'), sortable: false },
        { key: 'title', label: this.$t('Title'), sortable: false },
        { key: 'member', label: this.$t('Member'), sortable: false },
        { key: 'partner', label: this.$t('Partner'), sortable: false },
        { key: 'start', label: this.$t('Start'), sortable: false },
        { key: 'end', label: this.$t('End'), sortable: false },
        { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null ? store.state[STORE_MODULE_NAME].respData.data : []
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null ? store.state[STORE_MODULE_NAME].respData.max : 0
    },
    respDataPartner() {
      return store.state[STORE_MODULE_NAME].respDataPartner != null ? store.state[STORE_MODULE_NAME].respDataPartner.data : []
    },
    queriedItemsPartner() {
      return store.state[STORE_MODULE_NAME].respDataPartner != null ? store.state[STORE_MODULE_NAME].respDataPartner.max : 0
    },
  },
  watch: {
    day(newData, oldData) {
      const array = newData.split('-')
      console.log(array)
      // eslint-disable-next-line radix
      console.log(this.formatDate(new Date(parseInt(array[2]), parseInt(array[1]) - 1, parseInt(array[0]))), oldData)
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        // eslint-disable-next-line radix
        day: this.formatDate(new Date(parseInt(array[2]), parseInt(array[1]) - 1, parseInt(array[0]))),
        profilePartnerId: this.profilePartnerId,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
      // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    // eslint-disable-next-line no-unused-vars
    profilePartnerId(newData, oldData) {
      this.profilePartnerId = newData
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        // eslint-disable-next-line radix
        day: this.day,
        profilePartnerId: this.profilePartnerId,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
      // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    const obj = {
      currentPage: this.currentPage,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
      day: this.day,
      profilePartnerId: this.profilePartnerId,
    }

    this.show = true
    store
      .dispatch(`${STORE_MODULE_NAME}/get`, obj)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        this.show = false
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
      // eslint-disable-next-line no-unused-vars
      }).catch(error => {
        this.show = false
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    const objPartner = {
      currentPage: this.currentPagePartner,
      pageSize: this.perPagePartner,
      searchQuery: this.searchPartner,
    }
    store
      .dispatch(`${STORE_MODULE_NAME}/getPartner`, objPartner)
      // eslint-disable-next-line no-unused-vars
      .then(result => {
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
      // eslint-disable-next-line no-unused-vars
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-right',
          props: {
            title: this.$t('Error'),
            icon: 'ErrorIcon',
            variant: 'danger',
            text: this.$t(error.response.data.message),
          },
        })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
      })
    this.typing = debounce(this.typing, 500)
    this.onSearchPartner = debounce(this.onSearchPartner, 500)
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
  },
  setup() {
    return { STORE_MODULE_NAME }
  },
  methods: {
    modalLinkShow(item) {
      this.modalDetailData = item
      this.isModalLinkActive = true
    },
    modalDetailShow(item) {
      this.modalDetailData = item
      this.isModalDetailActive = true
    },
    onSearchPartner(query) {
      this.searchPartner = query
      this.currentPagePartner = 1
      const obj = {
        currentPage: this.currentPagePartner,
        pageSize: this.perPagePartner,
        searchQuery: this.searchPartner,
      }
      store
        .dispatch(`${STORE_MODULE_NAME}/getPartner`, obj)
        .then(result => {
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    formatDate(date) {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('-')
    },
    currentTime() {
      this.day = this.formatDate(new Date(Date.now()))
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        day: this.day,
        profilePartnerId: this.profilePartnerId,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    typing(value) {
      console.log(value)
      this.searchQuery = value
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        day: this.day,
        profilePartnerId: this.profilePartnerId,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    sidebarAddNew() {
      this.sidebarData = {}
      this.isSidebarActive = true
    },
    sidebarEdit(item) {
      this.sidebarData = item
      this.isSidebarActive = true
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/delete`, id)
              .then(result => {
                this.show = false
                console.log('fetch Success : ', result)
              }).catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
        //  else {
        //   this.showToast(
        //     'warning',
        //     'top-right',
        //     `${this.$t('DELETE_CANCEL')}!`,
        //     'AlertCircleIcon',
        //     this.$t('DELETE_CANCEL'),
        //   )
        // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        day: this.day,
        profilePartnerId: this.profilePartnerId,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPage(page) {
      this.currentPage = page
      const obj = {
        currentPage: this.currentPage,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
        day: this.day,
        profilePartnerId: this.profilePartnerId,
      }
      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        .then(result => {
          this.show = false
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          this.show = false
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    nextPagePartner(page) {
      this.currentPagePartner = page
      this.profilePartnerId = ''
      const obj = {
        currentPage: this.currentPagePartner,
        pageSize: this.perPagePartner,
        searchQuery: this.searchPartner,
      }
      store
        .dispatch(`${STORE_MODULE_NAME}/getPartner`, obj)
        .then(result => {
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.b-col-custom {
  margin-top: 0.5rem;
}
</style>
